"use client";
import React, { useMemo } from 'react';
import { SlotContainerProps } from './types';
import { useSlotContext } from './SlotContext';

/**
 * SlotContainer 组件
 * 在父组件中定义一个占位符，用于渲染子组件提供的内容
 */
export const SlotContainer: React.FC<SlotContainerProps> = ({
  id,
  defaultContent,
  className,
}) => {
  // 获取插槽上下文
  const { slots } = useSlotContext();
  
  // 确定要渲染的内容：如果有对应 ID 的插槽内容则使用，否则使用默认内容
  const content = useMemo(() => {
    return slots[id] || defaultContent;
  }, [id, slots, defaultContent]);

  // 如果没有内容且没有默认内容，则不渲染任何内容
  if (!content) {
    return null;
  }

  // 渲染内容
  return (
    <div className={className}>
      {content}
    </div>
  );
};
